import { render, staticRenderFns } from "./ShowStudentsWithoutLessonsDialog.vue?vue&type=template&id=413f7ccd&scoped=true&"
import script from "@/views/RosterManagement/ShowStudentsWithoutLessonsDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/RosterManagement/ShowStudentsWithoutLessonsDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RosterManagement/show-students-without-lessons-dialog.scss?vue&type=style&index=0&id=413f7ccd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f7ccd",
  null
  
)

export default component.exports